import React from 'react'
import ItemView from '../UserDashboard/Items/Components/ItemView'
import { navigate } from 'js/services/Network'

export default function StepPage({
  current,
  page,
  backTo,
  children
}) {
  return (
    <div className='tw-bg-white new-pod-ui'>
      <div className='pod-container tw-p-6'>
        <h4>Get started as a seller on PayOnDelivery</h4>

        <div className="tw-my-8">
          <div className="tw-hidden md:tw-flex tw-items-center tw-gap-8">
            {[
              { n: 1, text: 'Create item' },
              { n: 2, text: 'Sign up' },
              { n: 3, text: 'Share checkout link' }
            ].map((step, i) => (
              <React.Fragment key={i}>
                <div className='tw-flex tw-gap-4 tw-items-center'>
                  <div className="from20-32 tw-flex tw-justify-center tw-rounded-full tw-items-center"
                    style={{ border: `1px ${step.n <= current ? '#6D60F6' : 'gray'} solid` }} >
                    <p style={{
                      fontWeight: step.n <= current ? 700 : 400,
                      color: step.n <= current ? '#6D60F6' : 'gray',
                      marginBottom: 0
                    }}>{step.n}</p>
                  </div>

                  <h5 className='tw-leading-relaxed' style={{
                    fontWeight: step.n <= current ? 700 : 400,
                    color: step.n <= current ? '#6D60F6' : 'gray',
                    marginBottom: 0
                  }}>
                    {step.text}
                  </h5>
                </div>
                {step.n !== 3 && <span className="tw-h-0 tw-flex-1" style={{ border: `1px ${step.n <= current ? '#6D60F6' : 'gray'} solid` }}></span>}
              </React.Fragment>
            ))}
          </div>

          <div className="md:tw-hidden tw-flex tw-gap-2 tw-justify-between">
            {[1, 2, 3].map((_, i) => (
              <div key={i} className={`tw-h-1.5 tw-flex-1 tw-rounded-full ${_ <= current ? 'tw-bg-secondary' : 'tw-bg-gray-400'}`}>
              </div>
            ))}
          </div>
        </div>

        <div className="added-item tw-grid md:tw-grid-cols-3 tw-gap-4 md:tw-gap-24 tw-mt-8 md:tw-mt-16">
          <div className='tw-space-y-4 md:tw-space-y-8 md:tw-col-span-2'>
            {backTo && <div className='tw-flex tw-gap-4 tw-items-center' onClick={() => { navigate(backTo, { replace: true }) }}>
              <img
                src="/images/icons/icon-left.svg"
                alt="back"
                width="16" height="17"
              />
              <p>Back</p>
            </div>}

            {children}
          </div>

          <div className='tw-space-y-4 md:tw-space-y-8'>
            <h5>Item preview</h5>

            {page && ((!page.primary_image || !page.title) ?
              <div className="tw-flex tw-flex-col tw-items-center tw-gap-4 md:tw-gap-8">
                <img
                  src="/images/v2/sellers/loading-img.png"
                  alt="Add Image"
                  style={{ height: '131px', width: '256px' }}
                />

                <p className='small'>
                  The Items you add to your checkout will be listed here.
                </p>
              </div> :
              <div className='tw-space-y-4'>
                <ItemView item={{
                  title: page.title,
                  price: page.price,
                  size: page.size,
                  quantity: page.quantity,
                  address: page.address,
                  images: [page.primary_image],
                }} />
              </div>)}
          </div>
        </div>
      </div>
    </div>
  )
}

